// extracted by mini-css-extract-plugin
module.exports = {"productcontent":"river-pro-portable-power-station_productcontent__dLSHM"};